export default function OnboardingProgress({ step }) {
  const steps = ["Business", "Settings", "Google", "Finish"];

  return (
    <div className="flex items-center gap-3 mb-8">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const active = step === stepNumber;
        const complete = step > stepNumber;

        return (
          <div key={label} className="flex items-center flex-1">
            <div
              className={`h-9 w-9 rounded-full flex items-center justify-center text-sm font-semibold ${
                active || complete
                  ? "bg-indigo-600 text-white"
                  : "bg-slate-100 text-slate-400"
              }`}
            >
              {stepNumber}
            </div>

            <span
              className={`ml-3 text-sm font-medium hidden sm:inline ${
                active ? "text-slate-900" : "text-slate-500"
              }`}
            >
              {label}
            </span>

            {index < steps.length - 1 && (
              <div className="h-px bg-slate-200 flex-1 mx-4" />
            )}
          </div>
        );
      })}
    </div>
  );
}
